import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt'

import artburnClient from './artburn_client';
import artburnDapp from './artburn_dapp';

import web3Dapp from './web3_dapp';
import web3Client from './web3_client';


import './assets/styles/tailwind.css';

const emitter = mitt()
const app = createApp(App)

app.config.globalProperties.artburnDapp = artburnDapp;
app.config.globalProperties.web3Dapp = web3Dapp;
app.config.globalProperties.hasProvider = false;

app.config.globalProperties.emitter = emitter;
emitter.on('ethereum-enabled', async (account) => {
    app.config.globalProperties.account = account
});

artburnClient.then(artburn => {
    app.config.globalProperties.artburnClient = artburn;
    emitter.emit('provider-detected');
    app.config.globalProperties.hasProvider = true;
});

web3Client.then(web3 => app.config.globalProperties.web3Client =  web3);

app.mount('#app');